import { render } from "./aPrint.vue?vue&type=template&id=1f70b2f6&ts=true"
import script from "./aPrint.vue?vue&type=script&lang=ts"
export * from "./aPrint.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__